/* eslint-disable max-len */
export default {
    button: 'Failed to complete the task, contact IT Support',

    confirming: {
        name: 'Changes agreed',
        notAgreed: 'Changes not agreed',
        cancel: 'Cancellation agreed',
        confirm: 'Have the order changes been agreed with the client?',
        cancelConfirm: 'Is the cancellation agreed with the client?',
        disband: 'Disband',
        callFailed: 'Failed to call',
    },

    formatting: {
        name: 'Generate',
        confirm: 'Confirm the completion of the order formation. After confirmation, it will be impossible to adjust the order.',
        confirmOk: 'Confirm',
        confirmCancel: 'Go back to changing the order',
        confirmAdditional: "Order formed! To print an order with a 'soft' check, go to the stationary PC.",
        textTooltip: 'It is impossible to collect an order until the number of ordered and the number of collected goods are equal, or until the reason for changing the unassembled item is indicated',
        textTooltipNeedPackage: 'Невозможно собрать заказ, пока количество заказанных товаров и количество собранных товаров не сравняются, или пока не будет указана причина изменения несобранной позиции, или пока не будет добавлен хотя бы 1 пакет',
        bvModal: 'Are there unused containers in the order, delete unused items?',
        minSum: 'The amount of the collected order cannot be less than {minSum} {currencyAbbreviation}! Order cancelled',
    },

    listDisbanding: {
        name: 'Disbanded',
        confirm: 'The order is disbanded?',
    },

    listPaying: {
        name: 'Paid and issued',
        confirm: 'Has the order been paid and issued to the client?',
    },

    listPrint: {
        name: 'Printed out',
        confirm: 'The documents are printed out',
        confirmOk: 'Yes',
        confirmCancel: 'No',
    },
};